import React, { ReactElement, useEffect, useMemo } from "react";
import { useFormikContext, ErrorMessage, Field } from "formik";
import { RadioButton } from "primereact/radiobutton";

interface RadioOption {
  label?: string;
  value: any;
  extendedLabel?: string | ReactElement;
}

const RadioButtonComponent: React.FC<any> = (props) => {
  const { name, label, extendedLabel, options, warn, errorRequired = true, Body, ...rest } = props;
  const { setFieldTouched, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (!isSubmitting) return;
    setFieldTouched(name, true, true);
  }, [isSubmitting, name, setFieldTouched]);

  const processedOptions = useMemo(
    () => options.map((option: RadioOption) => (typeof option === "string" ? { label: option, value: option } : option)),
    [options]
  );

  return (
    <div className={`w-full flex flex-column contextChildTable`} id={name.split(".").pop()}>
      {label && (
        <label htmlFor={name} className={rest.isRequired ? "isRequired mb-2" : "mb-2"}>
          {label}
        </label>
      )}
      {Body && <Body />}
      {extendedLabel && (
        <p className="helpertext">
          <i>{extendedLabel}</i>
        </p>
      )}
      <div className="flex flex-column">
        <Field
          name={name}
          {...rest}
          render={({ field, form }: any) => (
            <>
              {processedOptions.map((option: RadioOption) => (
                <div key={String(option.value)} className={`flex align-items-baseline flex-row ${rest.fieldClassName ?? ""}`}>
                  <RadioButton
                    className="cursor-pointer radio-btn"
                    {...field}
                    {...rest}
                    inputId={`${name}_${String(option.value)}`}
                    value={option.value}
                    checked={rest.value === option.value}
                    onChange={(e) => {
                      setFieldTouched(name, true, true);
                      form.setFieldValue(name, e.value);
                    }}
                  />
                  {option.label && (
                    <div>
                      <label htmlFor={`${name}_${String(option.value)}`} className="mx-2 mt-0">
                        {option.label}
                      </label>
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        />
      </div>
      {warn && <div className=" text-left fieldadv">{warn}</div>}
      {errorRequired && <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />}
    </div>
  );
};

export default RadioButtonComponent;
